var P = Object.defineProperty, S = Object.defineProperties;
var C = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, f = Object.prototype.propertyIsEnumerable;
var p = (o, e, r) => e in o ? P(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, c = (o, e) => {
  for (var r in e || (e = {}))
    m.call(e, r) && p(o, r, e[r]);
  if (t)
    for (var r of t(e))
      f.call(e, r) && p(o, r, e[r]);
  return o;
}, T = (o, e) => S(o, C(e));
var d = (o, e) => {
  var r = {};
  for (var l in o)
    m.call(o, l) && e.indexOf(l) < 0 && (r[l] = o[l]);
  if (o != null && t)
    for (var l of t(o))
      e.indexOf(l) < 0 && f.call(o, l) && (r[l] = o[l]);
  return r;
};
import { jsxs as a, jsx as s } from "react/jsx-runtime";
import i from "../../../node_modules/prop-types/index.es.js";
import E from "react";
import * as R from "./style.es.js";
import { Toggle as _, ToggleBody as k, ToggleLabel as w, ToggleInput as z, ToggleSlider as B } from "./style.es.js";
import { Typography as b } from "../../Typography/Typography.es.js";
import { X_POSITION as y } from "../../../constants/position.es.js";
import { COMPONENT_SIZE as O } from "../../../constants/sizes.es.js";
const n = E.forwardRef((L, N) => {
  var g = L, {
    disabled: o = !1,
    error: e = !1,
    helperText: r,
    label: l,
    labelPosition: h = y.left,
    name: u,
    onChange: j,
    size: v = O.md,
    success: x = !1
  } = g, I = d(g, [
    "disabled",
    "error",
    "helperText",
    "label",
    "labelPosition",
    "name",
    "onChange",
    "size",
    "success"
  ]);
  return /* @__PURE__ */ a(_, { size: v, error: e, success: x, disabled: o, labelPosition: h, children: [
    /* @__PURE__ */ a(k, { children: [
      /* @__PURE__ */ s(b, { variant: "body2", children: l }),
      /* @__PURE__ */ a(w, { children: [
        /* @__PURE__ */ s(z, T(c({ type: "checkbox", name: u, onChange: j, disabled: o }, I), { ref: N })),
        /* @__PURE__ */ s(B, {})
      ] })
    ] }),
    r && /* @__PURE__ */ s(b, { variant: "caption1", children: r })
  ] });
});
n.S = R;
n.displayName = "Toggle";
n.propTypes = {
  disabled: i.bool,
  error: i.bool,
  helperText: i.string,
  label: i.oneOfType([i.string, i.node]),
  labelPosition: i.oneOf(Object.values(y)),
  name: i.string,
  onChange: i.func,
  size: i.oneOf(Object.values(O)),
  success: i.bool
};
export {
  n as Toggle
};
//# sourceMappingURL=Toggle.es.js.map
